<template>
  <div class="container-fluid px-sm-0 px-md-5">
    <div class="  d-flex px-sm-0 my-3">
      <vs-button :active="activeNav == index " size="small" danger border v-for="(nav, index) in navs" :key="index"
        @click="navChange(index)" style="margin:8px !important;margin-bottom:5px; padding: 4px; ">
        {{ nav.title }}
      </vs-button>
    </div>
 

    <div>
      <VueJustifiedLayout v-if="galleryData.data" :items="galleryData.data" :options="{
  containerPadding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  forceAspectRatio: 0,
  fullWidthBreakoutRowCadence:0,
  showWidows: true,
  targetRowHeight:280,
  boxSpacing:3
}">
        <template slot-scope="{ item, index }">
          <router-link v-if="loader" :to="{
            name: 'details',
            params: { id: item.id },
            query: {
              image: item.image,
              height: item.height,
              width: item.width,
              pres: (item.height / item.width) * 100,
            },
          }">
            <img :src="'https://pic.imamhussain.org/photos/preview/' + item.image" width="100%"
              class="animate__animated animate__fadeIn" :style="`animation-delay:.${index}s`" :alt="item.image" />
          </router-link>
        </template>
      </VueJustifiedLayout>
    </div>


    <div class="row justify-content-center animate__animated animate__fadeInUp my-3">
      <vs-button @click="loadMore" v-if="galleryData.next_page_url !=null" color="rgb(211, 186, 127)" flat gradient
        :loading="loading" size="large">
        تحميل المزيد
      </vs-button>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      navs: [],
      user_id: {
        default: 0
      }
    },
    data() {
      return {
        items: [],
        orderBy: "desc",
        activeNav: 0,
        loader: true,
        loading: false,
        page: 1,
      };
    },
    created() {
      //this.fetchItems();
    },

    computed: {
      galleryData() {
        return this.user_id != 0 ?
          this.$store.state.gallery.user_gallery :
          this.$store.state.gallery.all;
      }
    },

    methods: {
      scrollToTop() {
        window.scrollTo(0, 0);
      },
      navChange(index) {
        this.loader = false;
        this.loader = true;
        this.activeNav = index;
        var item = this.navs != null ? this.navs[this.activeNav] : 0;
        this.page = 1;
        var page = this.page;
        if (this.user_id != 0) {
          this.$store.dispatch("gallery/fetchUsergallery", {
            page,
            category: this.navs != null ? item.category : 0,
            sort: item.sort,
            clear: true,
          });
        } else {
          this.$store.dispatch("gallery/fetchgallery", {
            page,
            category: this.navs != null ? item.category : 0,
            sort: item.sort,
            clear: true,
          });
        }

        this.loading = false;

        setTimeout(() => {
          this.loader = true;
        }, 100);
      },
      created() {
        if (this.user_id != 0) {
          var page = 1;
          this.$store.dispatch('gallery/fetchUsergallery', {
            page,
            user: this.user_id
          });
        }

      },
      loadMore() {
        this.page++;
        var item = this.navs != null ? this.navs[this.activeNav] : 0;
        var page = this.page;
        if (this.user_id != 0) {
          this.$store.dispatch("gallery/fetchUsergallery", {
            page,
            category: this.navs != null ? item.category : 0,
            sort: item.sort,
            user: this.user_id
          });
        } else {
          this.$store.dispatch("gallery/fetchgallery", {
            page,
            category: this.navs != null ? item.category : 0,
            sort: item.sort,
          });
        }
        if(this.galleryData.data.length>this.galleryData.total-1) this.galleryData.next_page_url=null;
      },
    },
  };
</script>
<style scoped lang="scss">
  .c-bu {
    display: flex;
    margin: 12px auto;
    font-weight: bold;
    border: 1px solid #ccc;
    padding: 8px 20px;

  }

  .justified-container {}

  .justified-item {
    img {
      max-width: 100%;
    }
  }
</style>